<template>
  <el-dialog
    title="选择素材"
    :visible="dialogShow"
    :modal="true"
    append-to-body
    :before-close="onClose"
    width="1000px"
  >
    <img-or-text-material
      :is-select-mode="true"
      file-type="news"
      @selected="onSelect"
    ></img-or-text-material>
  </el-dialog>
</template>

<script>
import imgOrTextMaterial from "../../../../views/wx/accountConfig/materialHome/imgOrTextMaterial";
export default {
  name: "metarialImgTextDialog",
  components:{
    imgOrTextMaterial,
  },
  props:{
    selectType:{
      //news
      type:String,
      default:'news'
    },
    dialogShow:{
      type:Boolean,
      default:false
    }
  },
  methods:{
    onSelect(itemInfo){
      this.$emit('selected', itemInfo)
    },
    onClose(){
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
